import '../../content.scss'

import InfoList from './infobox'
import React from 'react'
import { Scrollbars } from 'react-custom-scrollbars'
import styled from 'styled-components'
import youarehere from '../../../../pages/images/youarehere.png'

//var ScrollArea = require('react-scrollbar');

let gmdv = require(`../../../../ghc_config`)

const DIVcenterInfo = styled.div`
  width: 100%;
  padding-left: 0px;
  list-style-type: none;
`
const CardInfo = styled.div`
  // as a MBICard except for flex-direction
  margin: 5px;
  position: relative;
  display: flex;
  -webkit-flex-direction: center;
  flex-direction: center;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 0.25rem;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.16), 0 2px 10px 0 rgba(0, 0, 0, 0.12);
  border: 0;
  font-weight: 400;
  .cI-bulletAttr {
    background-image: url(${youarehere});
    background-size: 20px;
    background-repeat: no-repeat;
    background-position: center center;
    width: 28px;
    height: 28px;
    text-align: center;
    color: #e7e7e8 !important;
    border-radius: 100%;
    order: 1;
  }
  .cI-content {
    display: block;
    width: 85%;
    margin-left: auto;
    order: 2;
    font-size: 0.8rem;
    .cI-title {
      font-size: 1.2em;
    }
    .cI-mainC {
      width: 70%;
      float: right;
      font-size: 0.7rem;
      @media only screen and (max-width: 1200px) {
        width: 63%;
      }
      @media only screen and (max-width: 992px) {
        width: 100%;
      }
      @media only screen and (max-width: 760px) {
        width: 78%;
      }
      @media only screen and (max-width: 500px) {
        width: 60%;
      }
    }
  }
`

const CentersList = (props) => {
  let newlocations
  if (props.overridedistancesort) {
    newlocations = gmdv.drupalDataNoSort(props.startPosition, props.locations)
  } else {
    //  distance sorting
    newlocations = gmdv.drupalData(props.startPosition, props.locations)
  }

  return (
    <>
      <DIVcenterInfo>
        <CardInfo className="my-2 p-1">
          <div className="cI-bulletAttr"></div>
          <div className="cI-content">
            <div className="cI-title black-text-Genesis">
              {newlocations.length} Centers with these attributes
            </div>
          </div>
        </CardInfo>
      </DIVcenterInfo>
      <Scrollbars universal autoHeight autoHeightMin={500} autoHeightMax={510}>
        {newlocations.length
          ? newlocations.map((item, index) => {
              if (item.node.field_latitude && item.node.field_longitude) {
                return (
                  <InfoList
                    key={index}
                    item={item}
                    index={index}
                    newlocations={newlocations}
                    //  handlers
                    handleToggleOpen={props.handleToggleOpen}
                    handleToggleCloseAll={props.handleToggleCloseAll}
                    //  starsdata
                    allPracticemaxRatings={props.allPracticemaxRatings}
                  />
                )
              }
            })
          : null}
      </Scrollbars>
    </>
  )
}

export default CentersList
